var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var width = "60.7%";
var height = "6.4%";
var left = "18.7%";
var isExternal = true;
var iniTop = 12.4;
var padding = 19.8 - iniTop;
var links = [
    ["Threat Horizon 2024: The disintegration of trust", "https://www.isflive.org/s/article/Threat-Horizon-2024-the-disintegration-of-trust-report?topicId=0TO0J0000009AODWA2"],
    ["Information Security in Mergers & Acquisitions", "https://www.isflive.org/s/article/Information-Security-in-Mergers-and-Acquisitions?topicId=0TO6M0000005B8PWAU"],
    ["Extinction level Attacks", "https://www.isflive.org/s/article/Extinction-Level-Attacks-A-survival-guide-Report"],
    ["Human-Centered Security Positively", "https://www.isflive.org/s/article/Human-Centred-Security-Positively-influencing-security-beviour"],
    ["Becoming a Next-Generation CISO", "https://www.isflive.org/s/article/Becoming-a-next-generation-CISO"],
    ["Human-Centered Security", "https://www.isflive.org/s/article/Human-Centred-Security-Addressing-psychological-vulnerabilities"],
    ["Building Tomorrow Security Workforce", "https://www.isflive.org/s/article/DOC-24113"],
    ["From Promoting Awareness to Embedding Behaviours", "https://www.isflive.org/s/article/DOC-10973"],
    ["Engaging with the Board", "https://www.isflive.org/s/article/DOC-6311"],
].map(function (line, idx) { return ({
    label: line[0],
    href: line[1],
    width: width,
    height: height,
    left: left,
    isExternal: isExternal,
    top: "".concat(iniTop + (padding * idx), "%"),
    target: "_blank"
}); });
export default __spreadArray(__spreadArray([], links, true), [{
        width: "28.7%",
        height: "5.4%",
        left: "34.7%",
        isExternal: isExternal,
        top: "82%",
        target: "_blank",
        label: "For more, please visit the ISF Library",
        href: "https://www.isflive.org/s/knowledge-library"
    }], false);
